export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'schedule' as const;

export const RELATIONSHIP_TYPES = {
  SHIFT: 'shift',
  TIME_OFF: 'time_off',
  EVENT: 'event',
  JOB: 'job',
  ROLE: 'role',
  TIME_OFF_BLACKOUT_PERIOD: 'time_off_blackout_period',
  SCHEDULE_AVAILABILITY: 'schedule_availability',
} as const;

export const SCHEDULE_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
} as const;
